module.exports = __webpack_public_path__ + "static/media/baca-background.6f9fcfb7.jpeg";